export interface KeywordEntity {
	name: string;
	hidden: boolean;
	guessed: boolean;
}

export function sanitize(value: string): string {
	return value.toLowerCase().replaceAll(/[^a-z0-9]/ig, "");
}
